import BaseMapCard from '@alltrails/shared/components/MapCard';
import { useLanguageRegionCode } from '@alltrails/language/hooks/useLanguageRegionCode';
import { useSelector } from '../../redux';
import useAdminCTAs from '../../hooks/useAdminCTAs';
import useAdminTrackLinks from './useAdminTrackLinks';
import { AdminMapHit, mapHitToMap } from './utils';

type MapCardProps = {
  currentResult: AdminMapHit;
  setIsPopupHovered: (isPopupHovered: boolean) => void;
};

const MapCard = ({ currentResult, setIsPopupHovered }: MapCardProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const displayMetric = useSelector(state => state.context.displayMetric);
  const adminTrackLinks = useAdminTrackLinks(currentResult);
  const adminCTAs = useAdminCTAs(adminTrackLinks);

  return (
    <BaseMapCard
      languageRegionCode={languageRegionCode}
      openInNewTab
      onCardMouseEnter={() => setIsPopupHovered(true)}
      onCardMouseLeave={() => setIsPopupHovered(false)}
      variant="small"
      map={mapHitToMap(currentResult)}
      useMetric={!!displayMetric}
      adminCTAs={adminCTAs}
    />
  );
};

export default MapCard;
